import api from './axios';

export const getCategories = async () => {
  const response = await api.get('/service-categories');
  return response.data;
};

export const getCategoryByType = async (type) => {
  const response = await api.get(`/service-categories/type/${type}`);
  return response.data;
};
